import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Sub/Sidebar";
import ChatArea from "../../Sub/ChatArea";
import socket from "../../Sub/socket";
import messageAudioNotification from "../../../images/message-notification.wav"

const ChatUI = () => {

  useEffect(() => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    socket.connect();
    socket.on("connect", () => {});
    return () => {
      socket.disconnect();
      socket.off("connect");
    };
  }, []);
  //notification
  const showBrowserNotification = (title, body) => {
    if (Notification.permission === "granted") {
      const notification = new Notification(title, { body });
      setTimeout(() => notification.close(), 10000);
    }
    // Play sound
    const audio = new Audio(
      messageAudioNotification
    ); // put this sound file in your public folder
    audio.play().catch((e) => console.error("Audio play error:", e));
  };

  return (
    <Container fluid className="whatsapp-ui">
      <Row>
        <Col md={3} className="max-100vh-scroll">
          <Sidebar showBrowserNotification={showBrowserNotification} />
        </Col>
        <Col md={9}>
          <ChatArea />
        </Col>
      </Row>

    </Container>
  );
};

export default ChatUI;
